export default "__VITE_ASSET__9dda47e2__"